import * as Type from './actionsTypes';

const INITIAL_STATE = {
  folhaPontos: [],
  selectedFolhaPonto: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.FOLHA_PONTO_UPDATE_STATUS_SUCCESS:
    case Type.FOLHA_PONTO_FIND_ONE_SUCCESS:
    case Type.FOLHA_PONTO_UPDATE_SUCCESS:
    case Type.FOLHA_PONTO_SAVE_SUCCESS: {
      return {
        ...state,
        selectedFolhaPonto: action.data
      }
    }
    case Type.FOLHA_PONTO_CLEAR_SELECTED: {
      return {
        ...state,
        selectedFolhaPonto: {}
      }
    }
    case Type.FOLHA_PONTO_DELETE_SUCCESS: {
      return {
        ...state,
        folhaPontos: state.folhaPontos.filter(a => a.id !== action.id)
      };
    }
    case Type.FOLHA_PONTO_CLEAN: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getFolhaPontos = state => state.rootState.folhaPonto.folhaPontos;
export const getSelectedFolhaPonto = state => state.rootState.folhaPonto.selectedFolhaPonto;
